// Topbar timestep scrubber. Wires the prev/next buttons + step label
// to the store. Buttons + label go inert (greyed, no-op) when the
// active dataset only exposes one step.

import { store, params } from '@store/instance';
import { INTENTS } from '@store/intents';

const STEP_INERT_TITLE_PREV = 'Single-snapshot dataset (previous timestep unavailable)';
const STEP_INERT_TITLE_NEXT = 'Single-snapshot dataset (next timestep unavailable)';
const STEP_ACTIVE_TITLE_PREV = 'Previous timestep ([)';
const STEP_ACTIVE_TITLE_NEXT = 'Next timestep (])';

export function installTimestepScrubber(): () => void {
    const wrap = document.getElementById('topbar-scrubber');
    const prevBtn = document.getElementById('topbar-step-prev') as HTMLButtonElement | null;
    const nextBtn = document.getElementById('topbar-step-next') as HTMLButtonElement | null;
    const label = document.getElementById('topbar-step-label');
    if (!wrap || !prevBtn || !nextBtn || !label) return () => { /* markup missing */ };

    const refresh = (): void => {
        const steps = params.availableSteps;
        const count = steps.length;
        const idx = steps.indexOf(params.currentStep);
        const inert = count <= 1;
        wrap.classList.toggle('is-inert', inert);
        prevBtn.disabled = inert || idx <= 0;
        nextBtn.disabled = inert || idx < 0 || idx >= count - 1;
        prevBtn.title = inert ? STEP_INERT_TITLE_PREV : STEP_ACTIVE_TITLE_PREV;
        nextBtn.title = inert ? STEP_INERT_TITLE_NEXT : STEP_ACTIVE_TITLE_NEXT;
        const shown = idx >= 0 ? idx : 0;
        label.textContent = `step ${shown} / ${Math.max(1, count) - 1}`;
    };

    const onPrev = (e: MouseEvent): void => {
        e.preventDefault(); e.stopPropagation();
        if (prevBtn.disabled) return;
        store.dispatch(INTENTS.STEP_PREV);
    };
    const onNext = (e: MouseEvent): void => {
        e.preventDefault(); e.stopPropagation();
        if (nextBtn.disabled) return;
        store.dispatch(INTENTS.STEP_NEXT);
    };
    prevBtn.addEventListener('click', onPrev);
    nextBtn.addEventListener('click', onNext);

    const offStep = store.subscribe('params.currentStep', () => refresh());
    const offSteps = store.subscribe('params.availableSteps', () => refresh());

    refresh();

    return () => {
        prevBtn.removeEventListener('click', onPrev);
        nextBtn.removeEventListener('click', onNext);
        offStep();
        offSteps();
    };
}
